import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import "./steps.css";

import { NavLink } from "react-router-dom";

const KycUploadPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section  pt-65 pb-130">
          <div className="container" bis_skin_checked={1}>
            <div className="row clearfix" bis_skin_checked={1}>
              <div
                className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
                bis_skin_checked={1}
              >
                <div className=" px-0 pb-0 mb-3" bis_skin_checked={1}>
                  <h2 className="mb-3" id="heading">
                    KYC Documents Upload
                  </h2>
                  <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                      <p className="mb-3 fs-5">
                        On our mobile app to complete your onboarding process we
                        require your Photo ID and a selfie. We use ID Scan
                        solution which takes less than a minute to complete this
                        for you.{" "}
                      </p>
                    </div>
                  </div>
                  {/*<div class="row justify-content-center">
                          <div class="col-4">

                              <button type="button" class="btn btn-primary video-btn2" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/qceO0YPfcVo" data-bs-target="#myModal">
                                  <i class="fa fa-play"></i> Watch Explainer Video
                              </button>
                          </div>
                      </div>*/}
                  <div id="msform" bis_skin_checked={1}>
                    {/* progressbar */}
                    <ul id="progressbar">
                      <NavLink to="/kycupload" bis_skin_checked={1}>
                        <li className="active" id="confirm">
                          <strong>1) Scanning Your Id</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/livenesscheck" bis_skin_checked={1}>
                        <li id="confirm">
                          <strong>2) Liveness Check</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/finishCheck" bis_skin_checked={1}>
                        <li id="confirm">
                          <strong>Finish</strong>
                        </li>
                      </NavLink>
                    </ul>
                    {/* fieldsets */}
                    <fieldset>
                      <div className="form-card" bis_skin_checked={1}>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4">How To Scan Id?</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid1.png"
                                alt="How to scan Id?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Try not to take the photo from any other
                                  angle. It will work regardless, but parallel
                                  is better.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid2.png"
                                alt="How to scan Id?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Try not to take the photo from any other
                                  angle. It will work regardless, but parallel
                                  is better.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr className="hrcss" />
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4 mt-2">What to avoid?</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid4.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please avoid flash or glares.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid6.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please avoid shadows over the ID.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid7.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please remove any background clutter.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid3.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text mb-4">
                                  Please make sure your details aren't blurry.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/scanid5.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please make sure you are not cropping or
                                  skewing the ID.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <NavLink
                        to="/livenesscheck"
                        type="button"
                         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="mt-5 sofax-default-btn pill sofax-header-btn text-whitee"
                        style={{
                          background: "#041b5f",
                          color: "white",
                          fontWeight: "bold",
                          height: "40px",
                          width: "200px",
                          fontSize: "24px",
                          padding: "8px",
                          borderRadius: "20px",
                        }}
                        bis_skin_checked={1}
                      >
                        Next
                      </NavLink>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default KycUploadPage;
